/* Pure Leaf cart fixes. Loaded just before pure-leaf.js. */
(function () {
  // 0. Top banner: free shipping + email offer, no countdown timer.
  function updateBanner() {
    var inner = document.querySelector('#plw-banner .plw-banner-inner');
    if (!inner) return;
    var target = document.getElementById('newsletter') ? '#newsletter' : '/pages/contact';
    inner.innerHTML =
      '<span class="plw-banner-msg">Free shipping on all orders</span>' +
      '<a class="plw-banner-code" href="' + target + '" style="color:inherit;text-decoration:none">' +
      'Join our email list for <strong>10% off</strong> &rarr;</a>';
  }

  try { updateBanner(); } catch (e) { console.error(e); }

  // 1. Shipping Protection starts unticked.
  //    pure-leaf.js adds protection to every cart unless sessionStorage
  //    "pl-protect-off" is set, so set it unless the shopper switched it on.
  try {
    if (sessionStorage.getItem('pl-protect-on') !== '1') {
      sessionStorage.setItem('pl-protect-off', '1');
    }
  } catch (e) {}

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('.pl-protect-toggle input');
    if (!input) return;
    try {
      if (input.checked) sessionStorage.setItem('pl-protect-on', '1');
      else sessionStorage.removeItem('pl-protect-on');
    } catch (e) {}
  });

  // 2. Local currency (e.g. Canada). Bundle prices on the page are typed in
  //    USD, so rebuild them from the localized jar price the way checkout
  //    does: jar price x qty, minus the USD tier discount converted at the
  //    store's rate. Runs before pure-leaf.js so its cart tiers match too.
  var USD_TIER_DISCOUNT = { 2: 1400, 3: 3800 };
  var localTiers = null;

  function money(cents) {
    return '$' + (cents % 100 === 0 ? cents / 100 : (cents / 100).toFixed(2));
  }

  function localizePrices() {
    var cur = window.Shopify && Shopify.currency;
    var jar = window.PL_PRICES && window.PL_PRICES.jar;
    if (!cur || !cur.active || cur.active === 'USD' || !jar) return;
    var rate = Number(cur.rate) || 1;
    var d2 = Math.round(USD_TIER_DISCOUNT[2] * rate);
    var d3 = Math.round(USD_TIER_DISCOUNT[3] * rate);
    localTiers = { 1: jar, 2: jar * 2 - d2, 3: jar * 3 - d3 };

    var map = {};
    map[4900] = jar;
    map[8400] = localTiers[2];
    map[10900] = localTiers[3];
    map[1400] = d2;
    map[3800] = d3;
    map[4200] = Math.round(localTiers[2] / 2);
    map[3633] = Math.round(localTiers[3] / 3);
    map[9800] = jar * 2;
    map[14700] = jar * 3;
    map[2500] = localTiers[3] - localTiers[2];
    if (window.PL_PRICES.protection) map[175] = window.PL_PRICES.protection;

    function convert(text) {
      return text.replace(/\$(\d{1,4}(?:\.\d{2})?)/g, function (match, amount) {
        var cents = Math.round(parseFloat(amount) * 100);
        return map[cents] ? money(map[cents]) : match;
      });
    }

    var drawer = document.querySelector('.pl-cart-drawer');
    if (drawer) {
      drawer.setAttribute('data-tier-1', localTiers[1]);
      drawer.setAttribute('data-tier-2', localTiers[2]);
      drawer.setAttribute('data-tier-3', localTiers[3]);
    }

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentNode;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT)$/.test(parent.nodeName)) return NodeFilter.FILTER_REJECT;
        if (parent.closest && parent.closest('.pl-cart-drawer')) return NodeFilter.FILTER_REJECT;
        return node.nodeValue.indexOf('$') === -1 ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) { node.nodeValue = convert(node.nodeValue); });

    document.querySelectorAll('[data-save]').forEach(function (el) {
      el.setAttribute('data-save', convert(el.getAttribute('data-save')));
    });
  }

  try { localizePrices(); } catch (e) { console.error(e); }

  function tierTotal(qty) {
    if (localTiers && localTiers[qty]) return localTiers[qty];
    var drawer = document.querySelector('.pl-cart-drawer');
    var fallback = { 1: 4900, 2: 8400, 3: 10900 };
    var data = drawer ? drawer.dataset : {};
    return Number(data['tier-' + qty] || data['tier' + qty]) || fallback[qty] || fallback[1] * qty;
  }

  // 3. Supply options show the bundle total (what the cart will show),
  //    with the per-jar price underneath.
  function showBundleTotals() {
    var options = document.querySelectorAll('.pl-pdp-opt[data-qty]');
    if (!options.length) return;
    var style = document.createElement('style');
    style.textContent = '.pl-pdp-opt-price{text-align:right;line-height:1.1}.pl-pdp-opt-price small{display:block;margin-top:.2rem}';
    document.head.appendChild(style);
    options.forEach(function (opt) {
      var qty = parseInt(opt.dataset.qty || '1', 10);
      var price = opt.querySelector('.pl-pdp-opt-price');
      if (!price) return;
      var total = tierTotal(qty);
      price.innerHTML = money(total) + (qty > 1 ? '<small>' + money(Math.round(total / qty)) + ' / jar</small>' : '');
    });
  }

  try { showBundleTotals(); } catch (e) { console.error(e); }

  // 4. Header and sticky add-to-cart buttons follow the supply picked in
  //    the main button.
  function syncCartButtons() {
    var main = document.querySelector('[data-pdp-cta]');
    if (!main) return;
    var qty = parseInt(main.dataset.qty || '1', 10);
    var label = 'Add ' + qty + (qty === 1 ? ' Jar' : ' Jars') + ' — ' + money(tierTotal(qty));
    document.querySelectorAll('.sticky-bar [data-variant], .pl-nav-actions [data-variant]').forEach(function (btn) {
      if (btn.disabled) return;
      if (main.dataset.variant) btn.dataset.variant = main.dataset.variant;
      btn.dataset.qty = String(qty);
      btn.textContent = label;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncCartButtons();
    var main = document.querySelector('[data-pdp-cta]');
    if (main) {
      new MutationObserver(syncCartButtons).observe(main, { attributes: true, attributeFilter: ['data-qty', 'data-variant'] });
    }
  });
})();
